import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
  error:{}
}

export const GeteditAdminStaffSlice = createSlice({
  name: 'GeteditAdminStaff',
  initialState,
  reducers: {
    GetEditAdminStaff_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    GetEditAdminStaff_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    GetEditAdminStaff_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_GetEditAdminStaff_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {GetEditAdminStaff_request, GetEditAdminStaff_success, GetEditAdminStaff_failure, Clear_GetEditAdminStaff_Check } = GeteditAdminStaffSlice.actions

export default GeteditAdminStaffSlice.reducer